import DashboardLayout from '@/components/layouts/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useTour } from '@/contexts/TourContext';
import React from 'react';

const HelpCenterPage = () => {
   const { startTour } = useTour();

   const helpSections = {
      'Getting Started': {
         content: [
            {
               title: 'Creating Your First Application',
               description: 'Learn how to create and submit your first application',
               videoUrl: '#',
               tourSteps: applicationsTourSteps,
            },
            // Add more tutorials
         ]
      },
      'User Guide': {
         content: [
            {
               title: 'Managing Applications',
               description: 'Understanding the application lifecycle',
               sections: [
                  {
                     title: 'Application Status',
                     content: 'Learn about different application statuses...'
                  },
                  // Add more sections
               ]
            },
         ]
      },
      'FAQs': {
         content: [
            {
               question: 'How long does the application process take?',
               answer: 'Processing times vary by application type...'
            },
            // Add more FAQs
         ]
      }
   };

   return (
      <DashboardLayout
         title="Help Center"
         description="Find guides, tutorials, and answers to common questions"
      >
         <Tabs defaultValue="getting-started">
            <TabsList>
               {Object.keys(helpSections).map(section => (
                  <TabsTrigger key={section} value={section.toLowerCase()}>
                     {section}
                  </TabsTrigger>
               ))}
            </TabsList>

            {Object.entries(helpSections).map(([section, { content }]) => (
               <TabsContent key={section} value={section.toLowerCase()}>
                  <div className="grid gap-6 md:grid-cols-2">
                     {content.map((item, index) => (
                        <Card key={index}>
                           <CardHeader>
                              <CardTitle>{item.title}</CardTitle>
                           </CardHeader>
                           <CardContent>
                              {/* Render content based on type */}
                           </CardContent>
                        </Card>
                     ))}
                  </div>
               </TabsContent>
            ))}
         </Tabs>
      </DashboardLayout>
   );
};

export default HelpCenterPage;